export const ALLOW_SEARCH_IN_CURRENT_FOLDER_DATA_NAME = 'allowSearchInCurrentFolder'
export const FORECAST_LIST_DATA_TAB_NAME = 'forecastListTab'
export const COMPANY_INFO_DATA_TAB_NAME = 'CompanyInfoTab'
export const GUARD_SECTION_DATA_NAME = 'guardSectionName'
